import { TotalOperationsDTO, TotalsRequestDTO } from './../@core/models/home-models';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CommonDataDTO } from '@app/requests/model/combos-model';
import { AgentDTO } from '@app/requests/model/requests-model';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class HomeService {
  constructor(private _http: HttpClient) {}

  getEstablishment(agentDTO: AgentDTO): Observable<CommonDataDTO[]> {
    return this._http.post<CommonDataDTO[]>(environment.URL_BASE_REQUEST + environment.subUrlEstablishments, agentDTO);
  }

  getOperationsHome(dates: TotalsRequestDTO): Observable<TotalOperationsDTO[]> {
    return this._http.post<TotalOperationsDTO[]>(
      environment.URL_BASE_REQUEST + environment.subUrlLatestRequestsHome,
      dates
    );
  }
}
